// Utility functions for trip-related operations
// This file contains helper functions that can be shared across different trip components

// Helper function to get Persian trip type name
export const getTripTypePersian = (tripType: number | null | undefined): string => {
  if (tripType === null || tripType === undefined || tripType === 0) {
    return '';
  }
  
  const tripTypeMap: { [key: number]: string } = {
    1: 'ترنسفر',
    2: 'در اختیار',
    3: 'بین شهری'
  };
  return tripTypeMap[tripType] || '';
};

// Helper function to get Persian name for trip item type
export const getTripItemTypePersian = (type: number): string => {
  switch (type) {
    case 0: return 'هیچ کدام';
    case 1: return 'مسافت';
    case 2: return 'مدت زمان';
    case 100: return 'محدوده ترافیک';
    case 101: return 'حومه شهر';
    case 102: return 'زمان توقف';
    case 103: return 'رفت و برگشت';
    default: return 'نامشخص';
  }
};

// Helper function to get Persian name for car group
export const getGroupPersian = (group: number | null | undefined): string => {
  if (group === null || group === undefined) {
    return '';
  }
  
  switch (group) {
    case 0: return 'نامشخص';
    case 1: return 'گروه خودروهای برنزی';
    case 2: return 'گروه خودروهای نقره ای';
    case 3: return 'گروه خودروهای طلایی';
    case 4: return 'گروه خودروهای VIP';
    default: return 'نامشخص';
  }
};

// Helper function to get Persian status name
export const getTripStatusPersian = (status: number | null | undefined): string => {
  if (status === null || status === undefined) {
    return 'نامشخص';
  }
  
  switch (status) {
    case 0: return 'نامشخص';
    case 1: return 'در انتظار تایید سفر';
    case 2: return 'رزرو اولیه';
    case 3: return 'تخصیص راننده';
    case 4: return 'رزرو نهایی';
    case 5: return 'در حال سفر';
    case 6: return 'پایان سفر';
    default: return 'نامشخص';
  }
};

// Helper function to get trip state text for TravelHistory
export const getTripStateText = (state: number) => {
  switch (state) {
    case 0: return { text: 'در انتظار', color: 'orange' };
    case 1: return { text: 'تایید شده', color: 'green' };
    case 2: return { text: 'در حال انجام', color: 'blue' };
    case 3: return { text: 'تکمیل شده', color: 'green' };
    case 4: return { text: 'لغو شده', color: 'red' };
    default: return { text: 'نامشخص', color: 'default' };
  }
};
